var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 622,
    height: 412,
    viewBox: "0 0 622 412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 622,
    height: 412,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 622,
    height: 412,
    fill: "#f0ebe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-35.778-291.3C-403.437-240.508-704,72.013-704,516.026s300.563,756.3,668.222,807.324c339.07,47.03,545.634-28.99,657.672-85.95V620.352H546.675v-.115C227.439,620.237-30.292,858-30.292,1244.48c-53.382-9.93-93.576-17.46-148.646-42.8,2.637-23.97,3.165-349.392,3.059-685.768.106-336.377-.422-661.8-3.059-685.766,55.07-25.339,95.264-32.873,148.646-42.8,0,386.485,257.731,624.243,576.967,624.243H622V-205.466C509.856-262.423,303.4-338.328-35.778-291.3Z",
    fill: "#1d4854"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTop);
export default __webpack_public_path__ + "static/media/logoTop.c332be63eed4584c9b6bf632b0c2199e.svg";
export { ForwardRef as ReactComponent };